// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.top-box-shadow {
  box-shadow: none;
}

header {
  background: transparent !important;
}

.input {
  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.02) 0px 0px 0px 1px !important;
}

.tabs {
  padding: 0.5rem 0rem;
}

select.form-select {
  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.2) 0px 0px 0px 1px !important;
  color: #666;
  max-width: 170px;
}

.elibrary-filter {
  background: #fff;
  padding: 10px;
}

.notification-content-wrapper {
  height: calc(100vh - 60px);
  overflow-y: auto;
  overflow-x: hidden;
}

.policy-upload .modal-dialog {
  max-width: calc(100vw - 50px) !important;
}
.policy-upload .modal-dialog .modal-content {
  width: 100% !important;
}
.policy-upload .modal-dialog .modal-body {
  padding: 0px !important;
}
.policy-upload .modal-dialog ::ng-deep .card {
  box-shadow: none !important;
}
.policy-upload .modal-dialog ::ng-deep .card .card-body {
  min-height: calc(100vh - 300px) !important;
}

.modal-dialog .modal-content {
  max-width: calc(100vw - 50px);
}
.modal-dialog .modal-header {
  justify-content: space-between;
}
.modal-dialog .modal-body {
  height: calc(100vh - 150px);
  overflow-y: auto;
  scrollbar-width: none;
  background: #fafafa !important;
}
.modal-dialog .modal-body .field.pos-relative {
  background: #fff !important;
}
.modal-dialog .fa-solid {
  font-size: 1.5rem !important;
  color: #fff !important;
}
.modal-dialog .btn-primary {
  background: var(--primaryColor) !important;
  color: #fff !important;
}
.modal-dialog .btn-cancel {
  background-color: #eee;
  color: #111;
}
.modal-dialog .btn {
  padding: 0.3rem 0.8rem !important;
}

.modal.fade {
  background: rgba(0, 0, 0, 0.2);
}

.modal.show {
  display: block;
}

.modal-header {
  background: var(--primaryColor);
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/app/components/ai-library/ai-library/e-library-details/ai-library-details.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;AACJ;;AAEA;EACI,kCAAA;AACJ;;AACA;EACE,kGAAA;AAEF;;AAAA;EACI,oBAAA;AAGJ;;AADA;EACI,iGAAA;EACA,WAAA;EACA,gBAAA;AAIJ;;AAFA;EACI,gBAAA;EACA,aAAA;AAKJ;;AAHA;EACI,0BAAA;EACA,gBAAA;EACA,kBAAA;AAMJ;;AAHI;EACI,wCAAA;AAMR;AALQ;EACI,sBAAA;AAOZ;AALQ;EACI,uBAAA;AAOZ;AAJS;EACG,2BAAA;AAMZ;AALY;EACI,0CAAA;AAOhB;;AADI;EACI,6BAAA;AAIR;AAFI;EACI,8BAAA;AAIR;AAFI;EACE,2BAAA;EACE,gBAAA;EACA,qBAAA;EACA,8BAAA;AAIR;AAFQ;EACI,2BAAA;AAIZ;AADI;EACI,4BAAA;EACA,sBAAA;AAGR;AADI;EACI,0CAAA;EACA,sBAAA;AAGR;AADI;EACI,sBAAA;EACA,WAAA;AAGR;AADI;EACI,iCAAA;AAGR;;AAAA;EACI,8BAAA;AAGJ;;AADA;EACI,cAAA;AAIJ;;AAFA;EACI,+BAAA;EACA,WAAA;AAKJ","sourcesContent":[".top-box-shadow{\n    box-shadow: none;\n}\n\nheader{\n    background: transparent !important;\n}\n.input{\n  box-shadow:  rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.02) 0px 0px 0px 1px !important;\n}\n.tabs{\n    padding:.5rem 0rem;\n}\nselect.form-select{\n    box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.2) 0px 0px 0px 1px !important;\n    color: #666;\n    max-width:170px;\n}\n.elibrary-filter{\n    background:#fff;\n    padding:10px;\n}\n.notification-content-wrapper{\n    height:calc(100vh - 60px);\n    overflow-y: auto;\n    overflow-x: hidden;\n}\n.policy-upload{\n    .modal-dialog{\n        max-width:calc(100vw - 50px) !important;\n        .modal-content{\n            width:100% !important;\n        }\n        .modal-body{\n            padding:0px !important;\n         }\n\n         ::ng-deep .card{\n            box-shadow: none !important;\n            .card-body{\n                min-height: calc(100vh - 300px) !important;\n            }\n        }\n    }\n}\n.modal-dialog{\n    .modal-content{\n        max-width:calc(100vw - 50px);\n    }\n    .modal-header{\n        justify-content: space-between;\n    }\n    .modal-body{\n      height:calc(100vh - 150px);\n        overflow-y: auto;\n        scrollbar-width: none;\n        background: #fafafa !important;\n\n        .field.pos-relative{\n            background: #fff !important;\n        }\n    }\n    .fa-solid{\n        font-size:1.5rem !important;\n        color:#fff !important;\n    }\n    .btn-primary{\n        background: var(--primaryColor) !important;\n        color:#fff !important;\n    }\n    .btn-cancel{\n        background-color:#eee;\n        color:#111;\n    }\n    .btn{\n        padding:.3rem .8rem !important;\n    }\n}\n.modal.fade{\n    background:rgba(0,0,0,0.2);\n}\n.modal.show{\n    display: block;\n}\n.modal-header{\n    background: var(--primaryColor);\n    color:#fff;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
